import React from "react";
import { useLocation, Redirect } from "react-router";
import { useAuth } from "@syos-music/auth";
import { GoogleOAuthProvider, useGoogleLogin } from "@react-oauth/google";
import qs from "qs";

import { darken, Container, Button } from "@mui/material";
import { Google as GoogleIcon } from "mdi-material-ui";

const GOOGLE_RED = "#d34122";

function LoginButton({ onSuccess }) {
  const login = useGoogleLogin({ onSuccess });

  return (
    <Button
      onClick={() => login()}
      startIcon={<GoogleIcon />}
      sx={{
        width: 140,
        color: "#fff",
        backgroundColor: GOOGLE_RED,

        "&:hover": {
          backgroundColor: (t) =>
            darken(GOOGLE_RED, t.palette.action.hoverOpacity),
        },
      }}
    >
      Google
    </Button>
  );
}

export default function LoginPage() {
  const location = useLocation();

  const { redirect } = qs.parse(location.search, { ignoreQueryPrefix: true });

  const { loginWithGoogle, isLoggedIn } = useAuth();

  if (isLoggedIn) return <Redirect to={redirect ?? "/"} />;

  return (
    <Container fixed align="center" sx={{ p: 4 }}>
      <GoogleOAuthProvider clientId="843938410143-ot18gqcgm62sanhiqqckjj15q07boot2.apps.googleusercontent.com">
        <LoginButton
          onSuccess={({ access_token }) =>
            loginWithGoogle({ googleAccessToken: access_token })
          }
        />
      </GoogleOAuthProvider>
    </Container>
  );
}
